import React from "react";
import loadable from "@loadable/component";

const _module2Component = {
  "products-categories": loadable(() => import("components/products-categories")),
  "card": loadable(() => import("components/product-card")),
  "testimonial": loadable(() => import("components/testimonial")),
  "videoTestimonial": loadable(() => import("components/video-testimonail")),
  "twoColumns": loadable(() => import("components/two-columns")),
  "twoColumnsVideo": loadable(() => import("components/two-columns-video")),
  "contactHero": loadable(() => import("components/contact-hero")),
  "fullTwoColumns": loadable(() => import("components/full-two-columns")),
  "heroSection": loadable(() => import("components/hero-section")),
  "heroes": loadable(() => import("components/heroes")),
  "singleCollectionProduct": loadable(() => import("components/collection-product")),
  "ambassador": loadable(() => import("components/professional-chefs")),
  "halfMediaDescription": loadable(() => import("components/half-media-description")),
  "floatingHero": loadable(() => import("components/floating-hero")),
  "doubleSlider": loadable(() => import("components/double-slider")),
  "missionBanner": loadable(() => import("components/our-mission-banner")),
  "textAccordion": loadable(() => import("components/text-accordion")),
  "textColumn": loadable(() => import("components/text-columns")),
  "mediaTimelineAccordion": loadable(() => import("components/media-list-accordion")),
  "productDetailsAccordion": loadable(() => import("components/product-details-accordion")),
  "topArticles": loadable(() => import("components/top-articles")),
  "mediaTab": loadable(() => import("components/media-tab")),
  "collectionList": loadable(() => import("components/collection-list")),
  "kitchenware": loadable(() => import("components/kitchenware-card")),
  "product-details-accordion": loadable(() => import("components/product-details-accordion")),
  "productHighlights": loadable(() => import("components/product-highlights")),
  "bestProductsReviews": loadable(() => import("components/best-products-reviews")),
  "top-articles": loadable(() => import("components/top-articles")),
  "richText": loadable(() => import("components/rich-text-section")),
  "contentsTable": loadable(() => import("components/contents-table")),
  "author": loadable(() => import("components/author-comment")),
  "siteReviews": loadable(() => import("components/product-reviews")),
  "basicSlider": loadable(() => import("components/basic-slide")),
  "imageHotspots": loadable(() => import("components/olavs-pane-banner")),
  "singleImage": loadable(() => import("components/single-image")),
  "newsletter": loadable(() => import("components/newsletter")),
  "iframe": loadable(() => import("components/iframe")),
  "orderByEmail": loadable(() => import("components/order-by-email")),
  "cart": loadable(() => import("components/tiered-discount-bar")),
  "referalFriends": loadable(() =>  import ("components/invite-friends")),
  "bigImageText": loadable(()=> import("components/big-image-text")),
  "bigImageSlider": loadable(()=> import("components/big-image-slider")),
  "categoryRecipes": loadable(() =>import("components/recipes-category-section")),
  "collectionsFilterSlider": loadable(() => import("components/collection-filter-slider")), 
  "tableProductInformation": loadable(() => import("components/table-product-information")),
  "productFeatures": loadable(() => (import("components/product-features"))), 
  "newHeroSection": loadable(() => import("components/new-hero-section")), 
  "textSlider": loadable(() => import("components/text-slider")),
  "codeBanner": loadable(() => import("components/code-banner")),
  "logoList":loadable(() => import("components/logo-list")),
  "imageComparisonWithText" :loadable(() => import("components/image-comparison-with-text")),
  "quoteWithReviews" :loadable(() => import("components/quote-with-reviews")),
  "videosModal" :loadable(() => import("components/videos-modal")),
  "imageWithText" :loadable(() => import("components/image-with-text")),
  "coatedProductDetail" :loadable(() => import("components/coated-product-detail")),
  "customFooter" :loadable(() => import("components/custom-footer")),
  "productReviews" :loadable(() => import("components/product-reviews")),
  "gorgiasHelpCenter" :loadable(() => import("components/gorgias-help-center")),
  "gorgiasContactFormular" :loadable(() => import("components/gorgias-contact-formular")),
  "privateSaleSignUp" :loadable(() => import("components/private-sale-sign-up")),
  "reviews" :loadable(() => import("components/reviews")),
};

const LoadableModule = ({ moduleData, type }) => {
  const RequestedModule = _module2Component[type];
  if (RequestedModule) return <RequestedModule data={moduleData} />;

  return (<span>{type}</span>);
};

export default LoadableModule;
